import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
/* import { message } from 'antd'; */
import { getWaveform, getComponentInfo, getWaveFormPostProcessEdgesInfo, getWaveFormJsonConfig, updateSpecInPPROCConfig } from '@/services/Sierra/results';
import NP from 'number-precision';
import { ICTypes } from '../../constants';
import { ResultData } from '@/services/Sierra';
import { getVerificationDataList, judgePostProcessSignalType } from '@/services/Sierra/helper/WaveformResultHelper';
import WaveForm from '../components/WaveForm';
import defaultColor from '@/constants/defaultColors';
import { recalcMeasure } from '../../store/result/action';
import resultOperation from '../../../../services/Result/Public/resultOperation';
import { WAVEFORM } from '../../../../services/Result/Public/resultConstants';
import { updateLibraryTree } from '../../store/library/action';
import { PPROC_VERSION } from '../../../../services/Sierra/results';
import debounce from '../../../../services/helper/debounceFn';

NP.enableBoundaryChecking(false);
class WaveformResult extends Component {
  constructor(props) {
    super(props);
    this.svgRef = createRef();
    this.contentRef = createRef();
    const { verificationId } = props;
    const resultOpera = resultOperation.getOperationByKey(verificationId, WAVEFORM) || {};
    this.state = {
      loading: true,
      driverList: [],
      selectedDriverKey: null,
      compInfo: [],
      currentInterfaceInfo: null,
      displayMode: 'Hi-Re',
      dataList: { Waveform: { list: [], show: [] } },
      portSelect: {},
      isPostProcess: false,
      allDesigns: [],
      resultOpera: resultOpera || {},
      expandedKeys: [],
      victimDataList: { WaveForm: { list: [], show: [] } },
    }
  }

  onRef = (ref) => {
    this.waveformSetting = ref;
  }

  componentDidMount = async () => {
    /* this.screenChange(); */
    const { verificationSubId, verificationId } = this.props;
    if (verificationSubId && verificationId) {
      if (!resultOperation.getOperation(verificationId)) {
        await resultOperation.getSettings(verificationId)
      }
      const resultOpera = resultOperation.getOperationByKey(verificationId, WAVEFORM) || {};
      this.setState({
        resultOpera
      }, () => {
        this.getJson(true)
      })
    }
  }

  componentDidUpdate = async (prevProps) => {
    const { verificationSubId, verificationId, recalc, hasVictim } = this.props;
    if ((verificationId !== prevProps.verificationId) && verificationSubId) {

      if (!resultOperation.getOperation(verificationId)) {
        await resultOperation.getSettings(verificationId)
      }
      const resultOpera = resultOperation.getOperationByKey(verificationId, WAVEFORM) || {};
      this.setState({
        driverList: [],
        selectedDriverKey: null,
        compInfo: [],
        currentInterfaceInfo: null,
        dataList: { Waveform: { list: [], show: [] } },
        victimDataList: { WaveForm: { list: [], show: [] } },
        portSelect: {},
        isPostProcess: false,
        allDesigns: [],
        resultOpera,
        displayMode: 'Hi-Re',
      }, () => {
        this.getJson(true);
      })
    }

    if ((verificationId && !recalc && recalc !== prevProps.recalc) && verificationSubId) {
      this.getJson()
    }

    if (hasVictim && hasVictim !== prevProps.hasVictim) {
      this.getJson(true);
    }
  }

  getJson = (isFirst) => {
    debounce(() => {
      const { verificationSubId, currentProjectId, verificationId } = this.props;
      ResultData.getVerificationJsonPromise(verificationSubId, verificationId, currentProjectId).then(res => {
        if (res) {
          this.designs = [];
          this.clock = res.Config ? res.Config.clock : ""
          let currentInterfaces = ResultData.getInterfaces();
          const designObj = {}
          currentInterfaces.forEach(item => {
            if (!designObj[item.pcbId]) {
              designObj[item.pcbId] = true;
              this.designs.push({
                id: item.pcbId,
                name: item.pcb,
                PCBID: item.PCBID,
              });
            }
          });

          let currentInterfaceInfo = ResultData.getInfo();
          const { components } = currentInterfaceInfo;
          const _filter = components.filter(comp => ICTypes.includes(comp.type));
          const driverList = _filter.map(comp => ({ designName: comp.pcb, name: comp.name, type: comp.type }));
          this.setState({
            currentInterfaceInfo,
            driverList,
            selectedDriverKey: driverList.length ? 0 : null,
            allDesigns: this.designs.map((item, index) => ({ ...item, color: defaultColor[index + 1] }))
          }, () => {
            this.getWaveform(isFirst);
          })
        }
      })
    }, 1000, false, "getJson")();
  }

  /*   componentWillUnmount() {
      window.removeEventListener('resize', this.resize);
    }
  
    screenChange() {
      window.addEventListener('resize', this.resize);
    }
  
    resize = () => {
      if (this.waveform) {
        this.waveform.plot.redrawPlot(this.svgRef.current);
      }
    } */

  updateState = (key, value) => {
    this.setState({ [key]: value });
  }

  getWaveform = async (isFirst) => {
    this.setState({
      loading: true
    }, async () => {
      const { displayMode, currentInterfaceInfo, resultOpera = {}, expandedKeys } = this.state;
      const { currentProjectId, verificationId, hasVictim, signalNameObj } = this.props;
      const { displayMode: displayModeOpera, portSelect } = resultOpera;
      let _displayMode = displayMode;
      if (isFirst) {
        _displayMode = displayModeOpera || displayMode
      }

      const isOriginal = _displayMode === 'Hi-Re' ? true : false;
      this.setState({
        displayMode: _displayMode
      })
      getWaveform(verificationId, isOriginal, currentProjectId).then(async waveform => {
        const events = {
          changeMouse: this.childComp.changeMouse,
          cancelMove: this.childComp.cancelMove,
          changeAxis: this.childComp.changeAxis,
        }
        waveform.plotWaveform({ svgElement: this.svgRef.current, events });
        this.waveform = waveform;
        const curves = waveform.getCurves();
        let compInfo = [];
        try {
          compInfo = getComponentInfo(currentInterfaceInfo, curves, this.designs);
        } catch (error) {
          //message.error('Error parsing the result file. ' + error)
          console.error('Error parsing the result file. ' + error)
          this.setState({
            loading: false,
          });
          return;
        }
        let newCompInfo = [], postProcessDataList = null, isPostProcess = false, postProcessConfig = null, isNewPPROC = false;
        // postProcessDataList = await getWaveFormPostProcessConfig(verificationId)
        try {
          postProcessDataList = await getWaveFormPostProcessEdgesInfo(verificationId)
          isPostProcess = true
        } catch (error) {
          console.error("Get edges file error: ", error);
        }
        try {
          postProcessConfig = await getWaveFormJsonConfig(verificationId)
          //update gpio spec by library
          postProcessConfig = await updateSpecInPPROCConfig(postProcessConfig);
        } catch (error) {
          console.error("Get pproc-config file error: ", error);
        }
        if (postProcessConfig) {
          postProcessDataList = judgePostProcessSignalType(postProcessDataList, postProcessConfig);
          isNewPPROC = postProcessConfig.version === PPROC_VERSION;
        }

        for (let info of compInfo) {
          const { curveName } = info;
          let postProcessData = postProcessDataList && postProcessDataList[curveName] ? { ...postProcessDataList[curveName], curveName } : {};
          newCompInfo.push({ ...info, postProcessData })
        }
        //draw clk components by default
        const { _compInfo, portSelect: newPortSelect, dataList, victimDataList } = getVerificationDataList(newCompInfo, hasVictim, signalNameObj);
        let _portSelect = portSelect && Object.keys(portSelect).length ? portSelect : newPortSelect
        let _newPortSelect = {}
        const signalNames = (currentInterfaceInfo.signals || []).map(item => item.name);

        for (let key in _portSelect) {
          if (!signalNames.includes(key)) {
            continue;
          }
          _newPortSelect[key] = _portSelect[key].filter(item => !!newCompInfo.find(it => it.signal === key && it.portSelectId === item))
        }
        const selectedComponentKeys = newCompInfo.filter(item => (_newPortSelect[item.signal] || []).includes(item.portSelectId)).map(item => item.curveIndex);

        let victimSignals = []
        if (_newPortSelect) {
          victimSignals = Object.values(signalNameObj)
            .filter(item => item.isVictim && Object.keys(_newPortSelect).includes(item.signalName))
            .map(it => it.signalName);
        }
        this.setState({
          loading: false,
          compInfo: _compInfo,
          portSelect: _newPortSelect,
          dataList,
          selectedComponentKeys,
          isPostProcess,
          postProcessConfig,
          isNewPPROC,
          expandedKeys: (!isFirst && !expandedKeys.includes("Victim")) || (isFirst || victimSignals.length) ? ["Result", "Victim", ...signalNames] : ["Result", ...signalNames],
          victimDataList
        });
        curves.forEach((curve, i) => {
          curve.visible = selectedComponentKeys.includes(i);
        });
        this.waveform.updataRawCurvePlot();
        if (resultOpera && resultOpera.processId && resultOpera.processSignal) {
          if (!signalNames.includes(resultOpera.processSignal) ||
            !newCompInfo.find(it => it.portSelectId === resultOpera.processId)) {
            this.setResultOpera({ processId: "", processSignal: "", selected: [] });
          }
        }

        if (victimSignals.length && isFirst) {
          this.childComp.initSelectedVictimSignals(victimSignals);
        }

        setTimeout(() => {
          this.childComp.setDefaultProcessData(signalNames)
        }, 500)
      })
    })
  }

  getDesignIdByName(name) {
    for (const design of this.designs) {
      if (design.name === name) {
        return design.id;
      }
    }
    return null;
  }

  displayModeChange = (e) => {
    this.setState({ displayMode: e.target.value }, () => {
      this.getWaveform();
      this.setResultOpera({ displayMode: e.target.value })
    });
  }


  updateGPIOSpecInPPROCConfig = (newPostProcessConfig) => {
    this.setState({
      postProcessConfig: JSON.parse(JSON.stringify(newPostProcessConfig || this.state.postProcessConfig || {}))
    })
  }

  updateExpandKeys = (keys) => {
    this.setState({
      expandedKeys: keys
    })
  }

  render() {
    const { loading, compInfo, displayMode, currentInterfaceInfo, portSelect, dataList,
      isPostProcess, allDesigns, postProcessConfig, resultOpera, isNewPPROC, expandedKeys,
      victimDataList
    } = this.state;
    const { verificationSubId, verificationId, currentProjectId, recalc, currentProgress,
      measurePanelVisible, libraryTreeInfo, interfaceTag, victimSummaryVisible, hasVictim } = this.props
    return <WaveForm
      {...this.resultListAction}
      onRef={this.onRef}
      compRef={(ref) => { this.childComp = ref }}
      loading={loading}
      compInfo={compInfo}
      portSelect={portSelect}
      dataList={dataList}
      displayMode={displayMode}
      currentInterfaceInfo={currentInterfaceInfo}
      waveform={this.waveform}
      svgRef={this.svgRef}
      updateState={this.updateState}
      waveformSetting={this.waveformSetting}
      verificationSubId={verificationSubId}
      displayModeChange={this.displayModeChange}
      verificationId={verificationId}
      isPostProcess={isPostProcess}
      allDesigns={allDesigns}
      sweep={false}
      currentProjectId={currentProjectId}
      postProcessConfig={postProcessConfig}
      recalcMeasure={this.props.recalcMeasure}
      recalc={recalc}
      progress={currentProgress}
      measurePanelVisible={measurePanelVisible}
      resultOpera={resultOpera}
      interfaceTag={interfaceTag}
      expandedKeys={expandedKeys}
      changeMeasureVisible={this.props.changeMeasureVisible}
      victimSummaryVisible={victimSummaryVisible}
      changeVictimSummaryVisible={this.props.changeVictimSummaryVisible}
      setResultOpera={this.setResultOpera}
      _updateLibraryTree={this.props._updateLibraryTree}
      libraryTreeInfo={libraryTreeInfo}
      updateGPIOSpecInPPROCConfig={this.updateGPIOSpecInPPROCConfig}
      isNewPPROC={isNewPPROC}
      clock={this.clock}
      updateExpandKeys={this.updateExpandKeys}
      hasVictim={hasVictim}
      victimDataList={victimDataList}
    />
  }

  colorChange = (e, id) => {
    const value = e.toHexString()
    if (value) {
      const { compInfo } = this.state;
      const { hasVictim, signalNameObj } = this.props;
      const curves = this.waveform.getCurves();
      const current = compInfo.find(item => item.curveName === id);
      if (current) {
        compInfo[current.curveIndex].color = value;
        curves[current.curveIndex].color = value;
        const { _compInfo, dataList, victimDataList } = getVerificationDataList(compInfo, hasVictim, signalNameObj);
        this.waveform.updataRawCurvePlot();
        this.setState({
          compInfo: _compInfo,
          dataList,
          victimDataList
        })
      }
    }
  }

  clearPort = () => {
    this.setState({
      portSelect: {}
    }, () => {
      this.setResultOpera({ portSelect: {} })
    });
  }

  changePort = (values, rowName) => {
    const { portSelect } = this.state;
    portSelect[rowName] = values;
    this.setState({
      portSelect
    }, () => {
      this.setResultOpera({ portSelect })
    });
    this.getCurves(portSelect);
  }

  changePorts = (groups) => {
    const { portSelect } = this.state;
    for (let item of groups) {
      if (item.values === null) {
        delete portSelect[item.rowName];
      } else {
        portSelect[item.rowName] = [...item.values];
      }
    }

    this.setState({
      portSelect
    }, () => {
      this.setResultOpera({ portSelect })
    });
    this.getCurves(portSelect);
  }

  getCurves = (portSelect) => {
    const { compInfo } = this.state;
    const keyMap = Object.keys(portSelect);
    let selectedComponentKeys = [];
    for (let key of keyMap) {
      const select = portSelect[key];
      select.forEach(s => {
        const info = compInfo.find(comp => comp.portSelectId === s);
        if (info) {
          selectedComponentKeys.push(info.curveIndex);
        }
      })
    }
    const curves = this.waveform.getCurves();
    curves.forEach((curve, i) => {
      curve.visible = selectedComponentKeys.includes(i);
    });
    // this.waveform.plot.removeCrossProbing(values)
    this.waveform.updataRawCurvePlot();
  }

  setResultOpera = (newSetting) => {
    const { verificationId } = this.props;
    const { resultOpera } = this.state;
    if (newSetting.portSelect && newSetting.portSelect.undefined) {
      delete newSetting.portSelect.undefined;
    }

    this.setState({
      resultOpera: { ...resultOpera, ...newSetting }
    }, () => {
      resultOperation.setOperationByKey(verificationId, WAVEFORM, { ...resultOpera, ...newSetting })
    })
  }

  resultListAction = {
    colorChange: this.colorChange,
    changePort: this.changePort,
    clearPort: this.clearPort,
    /*  _changeSelectAll: this.changeSelectAll, */
    changePorts: this.changePorts
  }
}

const mapState = (state) => {
  const { project, simulationReducer: { singleProgress }, resultReducer: { resultInfo: { verificationSubId, verificationId }, recalc }, library: { libraryTreeInfo } } = state.SierraReducer;
  const { currentProjectId } = project;
  const currentProgress = singleProgress.find(item => item.verificationId === verificationId)
  return {
    currentProjectId,
    verificationSubId,
    verificationId,
    recalc,
    currentProgress: currentProgress ? currentProgress.progress : false,
    libraryTreeInfo
  }
}

const mapDispatch = (dispatch) => ({
  recalcMeasure(configList) {
    dispatch(recalcMeasure(configList))
  },
  _updateLibraryTree(type) {
    dispatch(updateLibraryTree(type))
  }
})

export default connect(mapState, mapDispatch)(WaveformResult);